/*
 Rotator based on http://kenwheeler.github.io/slick/ plugin
 */

bq.rotator = function (element, options) {
    this.options  = options;
    this.$element = $(element);
};

bq.rotator.DEFAULTS = {
    autoplay:           true
    , autoplaySpeed:    5000
    , dots:             true
    , slidesToScroll:   1
    , slidesToShow:     1
    , arrows:           false
};

bq.rotator.prototype = {
    init: function () {
        bq.debug.log("Rotator : init()", this.$element);

        this._createRotator();
    },

    _createRotator: function () {
        var $carouselWrapper = this.$element.children('.carousel-wrapper'),
            _tempAutoplay,
            slideCount = $carouselWrapper.children().length;

        if (slideCount <= 1) {
            this.options.dots = false;
        }

        //Don't display until position has bee calculated
        $carouselWrapper.on('setPosition', function (){

            $(this).children().css('display', 'block');

            /**
             * For columns within a slider. Columns should have 'hidden' class in order to prevent display  before
             * position calculation.
             */
            $(this).find('.slick-list .slick-track > div').removeClass('hidden');

        });

        _tempAutoplay = this.options.autoplay;
        this.options.autoplay = false;
        $carouselWrapper = $carouselWrapper.slick(this.options);

        if(_tempAutoplay) {
            $carouselWrapper.slick('slickPlay');
        }

        $('li', '.slick-dots').on('click.slick', {}, function(){
            $carouselWrapper.slick('slickPause');
        });

    }
};


// ROTATOR PLUGIN DEFINITION
// =======================

var rotatorOld = $.fn.rotator;

$.fn.rotator = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.rotator');
        var options = $.extend({}, bq.rotator.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) {
            $this.data('bq.rotator', (data = new bq.rotator(this, options)));
        }
        data.init();
    });
};

$.fn.rotator.Constructor = bq.rotator;

// ROTATOR NO CONFLICT
// =================

$.fn.rotator.noConflict = function () {
    $.fn.rotator = rotatorOld;
    return this;
};

// FORM FILL DATA-API
// ==============

bq.rotatorInit = function () {
    $('[data-bq="rotator"]').each(function () {
        var el = $(this);
        if (el.data('bq.rotator')) {
            return;
        }
        el.rotator(el.data());
    });
};

bq.init.push(bq.rotatorInit);
